import { useTranslation } from 'react-i18next';
import type { TransportMode } from '~/hooks/useTransportState';

type LoadsCoveredLabelProps = {
  loadsCovered: number | null | undefined;
  transport?: TransportMode;
};

const TRANSPORT_MODE_LABEL_KEYS: Record<TransportMode, string> = {
  truck: 'order_builder.canned_tally_calculator.trucks',
  railcar: 'order_builder.canned_tally_calculator.railcars',
  container: 'order_builder.canned_tally_calculator.containers',
};

export function LoadsCoveredLabel({
  loadsCovered,
  transport,
}: Readonly<LoadsCoveredLabelProps>) {
  const { t } = useTranslation('order-builder');

  if (loadsCovered == null || !transport) {
    return null;
  }

  return (
    <span className="text-xs text-neut-500">
      {Math.ceil(loadsCovered)} {t(TRANSPORT_MODE_LABEL_KEYS[transport])}{' '}
      {t('order_builder.canned_tally_calculator.covered')}
    </span>
  );
}
